// index_style.js
import { zoom } from './zoomUtils.js';

export const globalStyles = {
  universal: {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    fontFamily: '"Bagel Fat One", system-ui',
    letterSpacing: zoom('0.1em')
  },

  htmlBody: {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--primary-dark)'
  },

  root: {
    width: '100%',
    height: '100%'
  }
};

// Function to apply global styles programmatically
export const applyGlobalStyles = () => {
  // Apply universal styles to all elements
  const style = document.createElement('style');
  style.textContent = `
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      font-family: "Bagel Fat One", system-ui;
      letter-spacing: ${zoom('0.1em')};
    }
    
    html, body {
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
      background-color: var(--primary-dark);
    }
    
    #root {
      width: 100%;
      height: 100%;
    }
  `;
  document.head.appendChild(style);
};